var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wxLogin"}},[_c('div',{staticClass:"wx-info"},[_c('img',{attrs:{"src":_vm.userInfo.headimgurl,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.userInfo.nickname))]),_vm._v(" "),_c('span',[_vm._v("登录成功")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f07c6b1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wxLogin.vue
// module id = null
// module chunks = 